import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

/**
 * Props for `ScholarshipForm`.
 */
export type ScholarshipFormProps =
  SliceComponentProps<Content.ScholarshipFormSlice>;

/**
 * Component for "ScholarshipForm" Slices.
 */
const ScholarshipForm: FC<ScholarshipFormProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      Placeholder component for ScholarshipForm (variation: {slice.variation})
      slices.
      <br />
      <strong>You can edit this slice directly in your code editor.</strong>
      {/**
       * 💡 Use your own AI agent with the Prismic CLI
       * 📚 Docs: https://prismic.io/docs/ai#create-slices
       */}
    </section>
  );
};

export default ScholarshipForm;
